import { DatePipe } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import { calendar } from "../../lib/calendar";
import * as fromRootStore from "../../reducers";
import { CommonService } from "../../services/common.service";
import { Combo2Service, ComboService, ExcelService, PartyService, ReportService } from "../../services/index";
import { PurchaseOrderService } from "../../services/purchaseorder.service";
declare var google;

@Component({
  selector: "purchaseOrder",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./partysalesvalueReport.html",
})
export class partysalesvalueReport implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  seasonList = [];
  typeList = ["Wholesale", "Retail", "Estimate"];
  gridOptions: any;
  
  dataList = [];
  qualityList: any;
  colorList = [
    "lightgoldenrodyellow",
    "rgb(240 249 249)",
    "bisque",
    "lightcyan",
    "rgb(243 228 247)",
    "rgb(249 245 235)",
    "#f9e2e2",
    "#efe7ef",
    "#ddf7dd",
    "gb(229 225 223)"
  ];
  codeList: any;
  widthList: any[];
  discountList: any[];
  seasonfinList = [];
  brandList: any[];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  finyearList = [];
  exceldata: any;
  viewList = ["TEAM VIEW", "ALLPARTY VIEW"];
  yearList = ["Calendar-Year", "Season-Year"];
  filter: any = {
    type: "",
    groupby: "incharger",
    finyear: "",
    from_date: '',
    to_date: '',
    view_type: "TEAM VIEW",
    year_type: "Calendar-Year",
    discount: [],
    fin_id: '',
    season_id: '',
    season: '',
    inch: ''
  };
 
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "wo_no",
    orderDir: "asc",
  };
  printConfig: any = {
    title: "WorkOrder Report",
    columns: [],
    rows: [],
  };

  partyList = [];
  partyCodeList = [];

  // @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
  // @ViewChild('nameTemplate') nameTemplate: TemplateRef<any>;
  // @ViewChild('addrTemplate') addrTemplate: TemplateRef<any>;
  //   @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  //   @ViewChild('partyDataTable') partyDataTable;

  finyearCtrl: FormControl = new FormControl();
  repViewCtrl: FormControl = new FormControl();
  repYearCtrl:FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  columns = [];
  partycodeList = [];
  seasonyearList = [];
  toggleCol = [];
  menu: any;
  reportTypeList = ["DESIGN NO", "PARTY", "PURCHASE"];
  reportName = "design_no";
  reportType = "Design";
  filterExpand = false;
  filterData: any;
  agentList$ = [];
  swatchList = ["YES", "NO"];
  sampList = ["YES", "NO"];
  agentList = [];
  user: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  orderList: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    private commonserv: CommonService,
    private partyservice: PartyService,
    private poservice: PurchaseOrderService,
    private excelService: ExcelService,
    public datePipe: DatePipe,
    private combo2Service: Combo2Service,
    private reportService: ReportService,
    public toasterService: ToasterService,
    public comboservice: ComboService
  ) { }

  ngOnInit(): void {
    this.getColumns();
    this.finyearCombo();
    this.getSeasonList();
    this.agentCombo();
    this.partyCombo();
    this.partyCodeCombo();
    this.widthlist();
    this.getDiscount();
    //  this.brandlist();
    this.toggleCol = Object.assign({}, this.columns);
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  getColumns() {
    this.columns = [
      {
        name: "SNo",
        prop: "sno",
        type: "sno",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        sortable: false,
        toggle: true,
        cellClass: "text-center",
        headerClass: "text-center",
      },
      {
        name: "WO.NO",
        prop: "wo_no",
        minWidth: 130,
        maxWidth: 130,
        width: 130,
        headerClass: "text-center",
      },
      {
        name: "Fabric Design",
        prop: "fab_design",
        minWidth: 130,
        maxWidth: 130,
        width: 130,
        headerClass: "text-center",
      },
      {
        name: "Shirt design",
        prop: "shirtdno",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        headerClass: "text-center",
      },
      {
        name: "Width",
        prop: "width",
        cellClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
        headerClass: "text-center",
      },
      {
        name: "Brand",
        prop: "brand",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        headerClass: "text-center",
      },
      {
        name: "F/S",
        prop: "ftot",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        headerClass: "text-center",
      },
      {
        name: "H/S",
        prop: "htot",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        headerClass: "text-center",
      },
      {
        name: "GR.Tot",
        prop: "gr_tot",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        headerClass: "text-center",
      },
    ];

    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: [],
    };
    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#party_code").focus();
    }, 100);
  }
  exportToExcel($event) {
    this.excelService.exportAsExcelFile(this.exceldata, this.title);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    //this.getSalesinvReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getOrderList();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    // this.getSalesinvReport();
  }

  widthlist() {
    this.poservice.widthlist({}).then((res: any) => {
      this.widthList = res.data;
    });
  }
  agentCombo() {
    this.partyservice.getAgentList({}).then((res: any) => {
      this.agentList = res;
    });
  }
  partyCombo() {
    let that = this;
    this.combo2Service.partyCombo().then((res: any) => {
      that.partyList = res.data;
    });
  }
  partyCodeCombo() {
    let that = this;
    this.combo2Service.partycodeCombo().then((res: any) => {
      that.partyCodeList = res.data;
    });
  }
  brandlist() {
    let data = this.commonserv.itemMaster();
    let brand = data.brand;
    this.brandList = brand;
    let style = data.style;
  }
  onCellClick(event) {
    if (this.filter.groupby == "incharger") {
      this.filter.inch = event.row.incharger;
      this.filter.groupby = "agent_wise"
    }
    else if (this.filter.groupby == "agent_wise") {
      this.filter.agent_id = event.row.agent_id;
      this.filter.groupby = "party_id"
    }
    this.getOrderList();
  }
  onbackbutton() {

    if (this.filter.groupby == "party_id") {
      this.filter.agent_id = "";
      this.filter.groupby = "agent_wise"
    }
    else if (this.filter.groupby == "agent_wise") {
      this.filter.inch = "";
      this.filter.groupby = "incharger"
    }

    this.getOrderList();
  }
applyFilter(): void {
    // this.filter.party_id = "";
    // this.filter.groupby = "incharger";
    // let from = this.filter.finyear.slice(0,4);
    // let to = this.filter.finyear.slice(5,9);
    // this.filter.from_date = from.concat('-04-01');
    // this.filter.to_date = to.concat('-03-31');
    this.getOrderList();
  }
  woFilter(wo_no) {
    this.getOrderList();
  }
  finyearCombo() {
    let that = this;
    this.combo2Service.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      that.filter.finyear = res.data[0].finyear;
      that.filter.fin_id = res.data[0].fin_id;
      that.finyearCtrl.setValue(res.data[0].fin_id);
      that.repViewCtrl.setValue(that.filter.view_type);
      that.repYearCtrl.setValue(that.filter.year_type);
      // that.onSelectFinyear(res.data[0].fin_id);
      that.getSeasonList();
    });
  }
  getSeasonList() {
    let params = {
      date: new Date().getFullYear(),
      page: 1,
      start: 0,
      limit: 100,
    };
    this.comboservice.getBrandNewSeason(params).then((res: any) => {
      this.seasonList = res;
      this.seasonyearList = res;
      this.allseason();
      this.onSelectdate('ALL');
      this.seasonCtrl.setValue(res[res["length"] - 1].season_id);
      this.getOrderList();
    });
  }

  loadSeasonList() {
    let that = this;
    that.reportService.getBrandNewSeason(this.filter).then(function (res) {
      that.seasonList = res;
      that.seasonyearList = res;
      that.allseason();
      that.onSelectdate('ALL');
    
      that.seasonCtrl.setValue(res[res["length"] - 1].season_id);
   
    });
  }
     ;
//   changeDate(val){
//     console.log(val,"check valueeeeeeeeeee")
//  }
  allseason() {
    let fin_id = parseInt(this.filter.fin_id);

    this.seasonList.forEach(() => {
      let seasonAll = {
        season: "ALL",
        season_id: this.seasonList[this.seasonList["length"] - 1].season_id + 1,
        fin_id: fin_id,
      };
      if (fin_id > 0) {
        this.seasonList.push(seasonAll);
      }
      fin_id = fin_id - 1;
    });
  }
  onSelectFinyear(id) {
    this.filter.season_id = "";
      this.filter.fin_id = id
    let seasonfinList = _.filter(this.seasonList, { fin_id: id });
    this.seasonfinList = seasonfinList;
    this.seasonCtrl.setValue(
      this.seasonList[this.seasonList["length"] - 1].season_id
    );
    this.onSelectdate('ALL');


     }
//   selectFinyear(year_type) {
//  if (year_type === 'SEASON YEAR') {
//       console.log(year_type, "value check");
//       this.filter.from_date = "";
//       this.filter.to_date = "";
//     } else {
//   let from = this.filter.finyear.slice(0, 4);
//       console.log(from);
//       let to = this.filter.finyear.slice(5, 9);
//       this.filter.from_date = from + "-04-01";
//       this.filter.to_date = to + "-03-31";
// }
//     this.applyFilter();
//  }


onSelectdate(type) {

  if(this.filter.year_type == 'Calendar-Year'){
   let obj = this.finyearList.find(e => e.fin_id == this.filter.fin_id)
    this.filter.from_date = obj.start_date;
    this.filter.to_date = obj.end_date;
  }
  
  else if (type == "ALL") {

    let id = this.filter.fin_id;
    let data = this.seasonyearList;
    let obj_data = data.filter(o => o.fin_id == id);

    let obj = obj_data.filter(o => o.season !== type);
    this.filter.from_date = obj[0].order_from;
    this.filter.to_date = obj[obj["length"] - 1].order_to;

  }
  else if (type !== "ALL") {

    let data = this.seasonyearList;
    let obj = data.find(o => o.season_id === this.filter.season_id);

    this.filter.from_date = obj.order_from;
    this.filter.to_date = obj.order_to;

  }
}
  displayFinyear(comboType: string, id: number) {
    let list: any = [];
    if (comboType == "Finyear") {
      list = this.finyearList;
    }
    if (id && list.length > 0) {
      let fitem = _.find(list, { fin_id: id });
      return fitem["finyear"];
    }
    return "";
  }
  displayFn(comboType: string, id: number) {
    this.filter.season_id = id;
    let list: any = [];
    let that = this;
    list = that.seasonList;

    if (id && list.length > 0) {
      let fitem = _.find(list, { season_id: id });
      return fitem["season"];
    }
    return "";
  }

  getOrderList(): void {
    this.filter.from_date = this.datePipe.transform(
      this.filter.from_date,
      "yyyy-MM-dd"
    );
    this.filter.to_date = this.datePipe.transform(
      this.filter.to_date,
      "yyyy-MM-dd"
    );
    if (this.filter.from_date || this.filter.to_date) {
      // this.filter.season_id = '';
      // this.filter.season = '';
    }
    //this.filter.order_to_date = this.datePipe.transform(this.filter.order_to_date, 'yyyy-MM-dd');
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      filter: JSON.stringify(this.filter),
    };
    let that = this;
    that.gridOptions = {
      loading: true,
      columns: [],
    };
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.reportService
      .getSalesReport(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.orderList = res.data;
        let temp = 0;
        res.data.forEach((el, ind) => {
          if (ind >= 10) {
            temp = temp + 1;
            if (temp == 10) {
              temp = 0;
            }
            el.background = that.colorList[temp];

          }
          else {
            el.background = that.colorList[ind];
          }
        });
        
          that.gridOptions = {
            cols: res.cols,
            columns: res.columns,
            data: res.data,
            loading: false,
          };

          let menuObj = {
            cellClass: "txtCenter",
            name: "Pcs.Per",
            prop: "percent1",
            width: "90",
          };
          let menuObj1 = {
            cellClass: "txtCenter",
            name: "PerDay.Pcs",
            prop: "perday_pcs",
            summary: "sum",
            width: "110",
          };
          that.gridOptions.columns.push(menuObj);
          that.gridOptions.columns.push(menuObj1);
          if(that.filter.groupby =="incharger" || that.filter.groupby == "agent_wise"){
            let menuObj3 = {
              cellClass: "txtCenter",
              name: "Tot.Customers",
              prop: "tot_parties",
              summary: "sum",
              width: "110",
            };
            that.gridOptions.columns.push(menuObj3);
          }

          let arrVal = res.data;
          let totalCnt = 0;
          let totalCnt1 = 0;

          for (var j = 0; j < arrVal.length; j++) {
            let temp = arrVal[j];
            totalCnt1 += parseFloat(temp.total_pcs);
          }
          for (var k = 0; k < arrVal.length; k++) {
            let temp1 = arrVal[k];
            let percent: any;
            percent = ((temp1.total_pcs / totalCnt1) * 100).toFixed(2);
            if (percent > 0) {
              res.data[k].percent1 = percent + "%";
            } else {
              res.data[k].percent1 = 0 + "%";
            }
            let per_pcs: any;
            per_pcs = (temp1.dif_pcs / temp1.dif_days).toFixed(2);
            if(that.filter.groupby =="incharger" || that.filter.groupby == "agent_wise"){
            per_pcs = (temp1.dif_pcs / temp1.dif_days).toFixed(2);
            res.data[k].perday_pcs = (per_pcs / Number(temp1.tot_parties)).toFixed(2);
            }
            // if (per_pcs > 0) {
            //   res.data[k].perday_pcs = per_pcs;
            // } 
            else {
              res.data[k].perday_pcs = per_pcs;
            }
         
          }
          res.data.map((li) => {
            totalCnt += li.invoiceamount;
          });
          res.data.map((li) => {
            li.per =
              Math.round((li.invoiceamount / totalCnt) * 100 * 100) / 100 + "%";

          });

          that.exceldata = that.getData(res.columns, res.data);
        });

      }
  openScreen(evant) {
        let tabObj = {};
        let mode = "View";
        let row = evant.row;
        tabObj = {
          action: "NewTab",
          params: {
            tabName: "EDIT SALES INVOICE",
            title: "EDIT SALES INVOICE",
            tabParent: "MASTER",
            mode: mode,
            data: row,
            name: "EDIT SALES INVOICE",
            sale_type: row.sale_type,
          },
        };
        this.tabUpdateEvent.emit(tabObj);
      }
  getDiscount() {
        this.poservice.getDiscount({}).then((res: any) => {
          this.discountList = res.data;
        });
      }

  getData(columns, data) {
        let cols = columns;
        let value = data;
        let rows =[],
        row,
        ind,
        type,
        val,
        rlen = data.length,
        clen = columns.length;

        for(let i = 0; i<data.length; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      let newrow = {
        Sno: sno,
      };
      for (let j = 1; j < clen; j++) {
        let type = cols[j].type,
          index = cols[j].index,
          prop = cols[j].prop,
          name = cols[j].name;

        newrow[name] = row[prop];
      }

      rows.push(newrow);
      sno++;
    }
    return rows;
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  refreshData() {
    let columns = this.columns,
      data = this.dataList,
      row = this.getSummaryRow(data, columns);
    data.push(row);
    this.page.count = data.length;
    // this.dataList = data;
  }

  getSummaryRow(data, columns) {
    let row = {
      type: "summary",
    };
    for (let i = 0; i < columns.length; i++) {
      let col = columns[i];
      switch (col.summary) {
        case "sum":
          let total = 0;
          for (let j = 0; j < data.length; j++) {
            let dat = data[j];
            total += dat[col.prop];
          }
          row[col.prop] = Math.round(total * 100) / 100;
          break;
        default:
          row[col.prop] = "";
          break;
      }
    }
    return row;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/salesReports/partysalesvalueReport.ts